import { captureException } from '@sentry/browser';
import { AxiosError } from 'axios/index';
import type { NextPage, NextPageContext } from 'next';

import { wrapperReduxToolkit } from '@/store';
import { loadDefaultData } from '@/store/utils/load-default-data';

import { HowItWorkPage } from '@/pages/how-it-work';

import { getMetaDataPage, TMetaDataReturned } from '@/entities/meta-seo';
import { TQuestion, getQuestions } from '@/entities/question';

import { HOW_IT_WORKS_URL } from '@/shared/constants/paths';
import { NOT_FOUND_PAGE, SERVER_ERROR, STATUS_CODE_OK } from '@/shared/constants/settings';

type TProps = {
    metaData: TMetaDataReturned;
    questions: TQuestion[];
};

const Page: NextPage<TProps> = ({ metaData, questions }) => {
    const { title, description } = metaData;

    return <HowItWorkPage title={title} description={description} questions={questions} />;
};

Page.getInitialProps = wrapperReduxToolkit.getInitialPageProps(
    ({ dispatch, getState }) =>
        async (context: NextPageContext) => {
            const { res, locale } = context;

            // Загрузка стора при серверном и клиенском рединге, общих настроек
            await loadDefaultData({
                getState,
                dispatch,
                locale: locale as string,
                context,
            });

            let statusCode = STATUS_CODE_OK;

            try {
                const response = await Promise.all([
                    getQuestions(locale as string, true),
                    getMetaDataPage(HOW_IT_WORKS_URL, locale as string),
                ]);

                return {
                    questions: response[0].data,
                    metaData: response[1],
                };
            } catch (err) {
                console.error('HowItWorks getInitialProps error', err);
                const error = err as AxiosError;
                statusCode = error.response?.status === NOT_FOUND_PAGE ? NOT_FOUND_PAGE : SERVER_ERROR;
                captureException(error);
            }

            if (res) {
                res.statusCode = statusCode;
            }

            return {
                statusCode,
            };
        },
);

export default Page;
